const popupInformation = {
  MobilityIndicators: {
    nbHabitants: {
      es: {
        speech: `<p class="popup-information-text-speech">
                El número de habitantes se obtiene a partir de una proyección de datos basada en los censos generales de población del INEI y del análisis de la evolución de la mancha urbana.
                </p>
                <p class="popup-information-text-conurbation">*El área metropolitana abarca toda la provincia de Cusco y los distritos vecinos de Anta, Cachimayo, Huaracondo, Pucyura, Zurite, Urcos, Andahuaylillas, Huaro, Lucre, Oropesa, Chinchero y Huayllabamba</p>
                `,
        source: `<p class="popup-information-text-source">INEI y proyecciones</p>`,
      },
    },
    tauxCroissanceAnnualise: {
      es: {
        speech: `<p class="popup-information-text-speech">
                La tasa de crecimiento anualizada se basa en las proyecciones de crecimiento anual del Perú a partir del último censo general de población del INEI.
                La evolución de la tasa de crecimiento anual de la población interna al perímetro de cada provincia se basa en las proyecciones de tasa de crecimiento anual del Perú por el INEI y las tasas de crecimiento anuales anteriores al último censo del INEI.
                </p>
                <p class="popup-information-text-conurbation">
                *El área metropolitana abarca toda la provincia de Cusco y los distritos vecinos de Anta, Cachimayo, Huaracondo, Pucyura, Zurite, Urcos, Andahuaylillas, Huaro, Lucre, Oropesa, Chinchero y Huayllabamba
                </p>
                `,
        source: `<p class="popup-information-text-source">INEI y proyecciones</p>`,
      },
    },
    kmBatisConstruits: {
      es: {
        speech: `<p class="popup-information-text-speech">
                El número de km² urbanizados corresponde a la superficie urbana ocupada, la cual incluye la superficie de las vías.
                </p>
                `,
        source: `<p class="popup-information-text-source">Estimación a partir del manzaneo MPC 2022</p>`,
      },
    },
    partActifsHabitants: {
      es: {
        speech: `<p class="popup-information-text-speech">
                El número de personas activas corresponde a las personas que residen en el área metropolitana* y que tienen un empleo a tiempo parcial o completo, formal o informal. Las personas activas sin empleo, como los desempleados, no se tienen en cuenta.
                </p>
                <p class="popup-information-text-conurbation">*El área metropolitana abarca toda la provincia de Cusco y los distritos vecinos de Anta, Cachimayo, Huaracondo, Pucyura, Zurite, Urcos, Andahuaylillas, Huaro, Lucre, Oropesa, Chinchero y Huayllabamba</p>
                `,
        source: `<p class="popup-information-text-source">EODH</p>`,
      },
    },
    densiteNette: {
      es: {
        speech: `<p class="popup-information-text-speech">
                Se trata de la población dividida por la superficie urbana ocupada, la cual incluye la superficie de las vías. Este indicador permite observar la evolución de la urbanización y la expansión urbana, para saber si la ciudad crece densificándose y/o extendiéndose. Una ciudad compacta utilizará menos espacio y será más fácil desarrollar en ella un transporte eficiente. Se reducirán los tiempos de desplazamiento y las emisiones.
                </p>
                `,
        source: `<p class="popup-information-text-source">Estimación a partir del manzaneo MPC 2022</p>`,
      },
    },
    nbEmplois: {
      es: {
        speech: `<p class="popup-information-text-speech">
                Este indicador sirve para observar los polos de atracción y generadores de viajes en el área metropolitana*.
                </p>
                <p class="popup-information-text-conurbation">*El área metropolitana abarca toda la provincia de Cusco y los distritos vecinos de Anta, Cachimayo, Huaracondo, Pucyura, Zurite, Urcos, Andahuaylillas, Huaro, Lucre, Oropesa, Chinchero y Huayllabamba</p>
                `,
        source: `<p class="popup-information-text-source">Información demográfica y de empleo base: incluye empleos observados, derivados de conteos de establecimientos y registros formales y registro de empleo público: proviene de la base de datos oficial de plazas y trabajadores del sector público</p>`,
      },
    },
    nbPersonnesMenage: {
      es: {
        speech: `<p class="popup-information-text-speech">
                El número de personas por hogar corresponde al número promedio de personas que viven en un mismo hogar.
                </p>
                `,
        source: `<p class="popup-information-text-source">EODH</p>`,
      },
    },
    partPopulationDesserteTc: {
      es: {
        speech: `<p class="popup-information-text-speech">
                Se trata de la parte de la población que reside a menos de 300 metros de una línea de transporte público. Es un indicador estratégico para evaluar el nivel de cobertura del transporte público.
                </p>
                `,
        source: `<p class="popup-information-text-source">Análisis cruzado de las rutas de transporte público con las bases de datos del Censo Poblacional de 2017 (INEI/CN 2017)</p>`,
      },
    },
    infrastructureCyclable: {
      es: {
        speech: `<p class="popup-information-text-speech">
                Una amplia red de infraestructura ciclovial mejora la seguridad de los ciclistas y fomenta un cambio modal hacia un modo de transporte activo y limpio.
                </p>
                `,
        source: `<p class="popup-information-text-source">Levantamiento</p>`,
      },
    },
    vehiculeAutomoteur: {
      es: {
        speech: `<p class="popup-information-text-speech">
                Se trata de una estimación del parque de autos, motos, taxis ilegales y taxis legales para el área metropolitana*.
                </p>
                <p class="popup-information-text-conurbation">
                *El área metropolitana abarca toda la provincia de Cusco y los distritos vecinos de Anta, Cachimayo, Huaracondo, Pucyura, Zurite, Urcos, Andahuaylillas, Huaro, Lucre, Oropesa, Chinchero y Huayllabamba
                </p>
                `,
        source: `<p class="popup-information-text-source">Parque de vehículos procedente del AAP, de la MPC y de aforos en campo.</p>`,
      },
    },
    parcBus: {
      es: {
        speech: `<p class="popup-information-text-speech">
                Se trata de la flota de buses operada en el área metropolitana* en rutas urbanas y rutas interurbanas. Por lo tanto, no se incluye la flota de transporte de personal, e transporte escolar o la red de combis y colectivos.
                </p>
                <p class="popup-information-text-conurbation">
                *El área metropolitana abarca toda la provincia de Cusco y los distritos vecinos de Anta, Cachimayo, Huaracondo, Pucyura, Zurite, Urcos, Andahuaylillas, Huaro, Lucre, Oropesa, Chinchero y Huayllabamba
                </p>
                `,
        source: `<p class="popup-information-text-source">Estimación a partir de declaraciones de los  transportistas</p>`,
      },
    },
    vitesseCommercialeBus: {
      es: {
        speech: `<p class="popup-information-text-speech">
                La velocidad comercial es la media de velocidad a la que va el bus, incluyendo las paradas. Permite medir el efecto de ciertas medidas, como por ejemplo carriles exclusivos o prioridad semafórica.
                </p>
                `,
        source: `<p class="popup-information-text-source">Registro de las TUC (Tarjeta Única de Circulación) </p>`,
      },
    },
    tauxImmobilite: {
      es: {
        speech: `<p class="popup-information-text-speech">
                La tasa de inmovilidad corresponde a la parte de la población que no realiza ningún viaje durante el día. Es el caso de algunas personas que trabajan desde casa (incluido el teletrabajo), las personas mayores, los niños o las personas que están enfermas. Distinguir las tasas de inmovilidad según el género proporciona información sobre la dinámica social y la movilidad de los territorios.
                </p>
                `,
        source: `<p class="popup-information-text-source">EODH</p>`,
      },
    },
    frequentationTransportPublic: {
      es: {
        speech: `<p class="popup-information-text-speech">
                La frecuentación del transporte público (TP) en bus corresponde al número de etapas realizados al día en las líneas de la red, incluyendo los transbordos. Ayuda para la lectura: en 2024, se realizaron una media de 509 198 viajes en tranvía al día durante el año.
                </p>
                `,
        source: `<p class="popup-information-text-source">EODH</p>`,
      },
    },
    motorisation: {
      es: {
        speech: `<p class="popup-information-text-speech">
                Las tasas de motorización corresponden al número de vehículos que poseen los hogares del área metropolitana*. Se trata de automóviles para la tasa de autos, y de motos, scooters y ciclomotores para la tasa de motos. Se expresa en número de vehículos por cada 1000 habitantes. La tasa de motorización es un indicador esencial para determinar la importancia del vehículo individual en el territorio. A menudo sigue las tendencias del producto interno bruto (PIB): cuanto más alto es, más vehículos habrá. Con la coyuntura actual (aumento de los precios del combustible y de los vehículos, transición energética), es interesante seguir la evolución de la tasa de motorización de los vehículos de dos ruedas motorizados, donde se observa un cambio modal del automóvil hacia este modo de transporte menos costoso para los hogares.
                </p>
                <p class="popup-information-text-conurbation">
                *El área metropolitana abarca toda la provincia de Cusco y los distritos vecinos de Anta, Cachimayo, Huaracondo, Pucyura, Zurite, Urcos, Andahuaylillas, Huaro, Lucre, Oropesa, Chinchero y Huayllabamba
                </p>
                `,
        source: `<p class="popup-information-text-source">EODH</p>`,
      },
    },
    tauxMobiliteQuotidien: {
      es: {
        speech: `<p class="popup-information-text-speech">
                El índice de movilidad corresponde al número de viajes realizados al día por los habitantes.
                </p>
                <p class="popup-information-text-conurbation">
                *El área metropolitana abarca toda la provincia de Cusco y los distritos vecinos de Anta, Cachimayo, Huaracondo, Pucyura, Zurite, Urcos, Andahuaylillas, Huaro, Lucre, Oropesa, Chinchero y Huayllabamba
                </p>
                `,
        source: `<p class="popup-information-text-source">EODH</p>`,
      },
    },
    repartitionModaleDeplacementsQuotidiens: {
      es: {
        speech: `<p class="popup-information-text-speech">
                La partición modal de los viajes diarios corresponde al número de viajes realizados cada día en el área metropolitana* por sus habitantes para cada uno de los modos existentes. Este indicador permite observar el equilibrio entre los medios colectivos y de gran capacidad (en particular, el transporte público) y los medios no motorizados, como la caminata y la bicicleta, frente a los medios motorizados, como el automóvil particular o los vehículos de dos ruedas motorizados, que generan más molestias (congestión, contaminación, consumo de espacio y recursos). El seguimiento de la evolución de la partición modal permite observar si se produce un cambio modal. Por lo general, la cuota modal del transporte público representa entre el 10 % y el 60 % del total de los modos de transporte.
                </p>
                <p class="popup-information-text-conurbation">
                *El área metropolitana abarca toda la provincia de Cusco y los distritos vecinos de Anta, Cachimayo, Huaracondo, Pucyura, Zurite, Urcos, Andahuaylillas, Huaro, Lucre, Oropesa, Chinchero y Huayllabamba
                </p>
                `,
        source: `<p class="popup-information-text-source">EODH</p>`,
      },
    },
    nbDeplacementsQuotidiens: {
      es: {
        speech: `<p class="popup-information-text-speech">
                El volumen de viajes diarios corresponde al número total de trayectos realizados cada día por los habitantes del área metropolitana*. Un viaje corresponde al trayecto realizado hasta el destino final por un motivo determinado, independientemente del número de medios de transporte utilizados durante dicho trayecto. Así, un viaje puede incluir varios medios de transporte, con conexiones. Sin embargo, un viaje no puede tener varios motivos a la vez. Por ejemplo, en el caso de un padre que va al trabajo y deja a su hijo en la escuela durante su trayecto en auto, se contabilizarán dos viajes: uno desde el domicilio hasta la escuela por el motivo «Acompañamiento» y otro por el motivo «Trabajo».
                </p>
                <p class="popup-information-text-conurbation">
                *El área metropolitana abarca toda la provincia de Cusco y los distritos vecinos de Anta, Cachimayo, Huaracondo, Pucyura, Zurite, Urcos, Andahuaylillas, Huaro, Lucre, Oropesa, Chinchero y Huayllabamba
                </p>
                `,
        source: `<p class="popup-information-text-source">EODH</p>`,
      },
    },
    emissionsGes: {
      es: {
        speech: `<p class="popup-information-text-speech">
                Las emisiones de gases de efecto invernadero (GEI) se calculan teniendo en cuenta el tipo de vehículo y su consumo energético, asociado a un factor de emisión. A continuación, las emisiones por modo se combinan con el número total de kilómetros recorridos anualmente por la flota de vehículos (conocida o estimada por cálculo). Este número se divide luego por la población total para obtener una relación de GEI por habitante y por año. El indicador se expresa en kgCO2/año/habitante equivalente.
                </p>
                `,
        source: `<p class="popup-information-text-source">Valores habituales de factores de emisión, viajes resultantes de la EODH, parque de vehículos procedente del AAP, de la MPC y de aforos en campo.</p>`,
      },
    },
    emissionsCo2: {
      es: {
        speech: `<p class="popup-information-text-speech">
                Las emisiones de gases de efecto invernadero (GEI) se calculan teniendo en cuenta el tipo de vehículo y su consumo energético, asociado a un factor de emisión. A continuación, las emisiones por modo se combinan con el número total de kilómetros recorridos anualmente por la flota de vehículos (conocida o estimada por cálculo). Este número se divide luego por la población total para obtener una relación de GEI por habitante y por año. El indicador se expresa en kgCO2/año/habitante equivalente.
                </p>
                `,
        source: `<p class="popup-information-text-source">Valores habituales de factores de emisión, viajes resultantes de la EODH, parque de vehículos procedente del AAP, de la MPC y de aforos en campo.</p>`,
      },
    },
    nbAccidents: {
      es: {
        speech: `<p class="popup-information-text-speech">
                Este indicador proporciona información sobre el número de accidentes con víctimas (mortales, heridos graves, heridos leves) ocurridos en la red de carreteras de la Región de Cusco.
                </p>
                `,
        source: `<p class="popup-information-text-source">Siniestros totales en la región del Cusco 2024 adaptado de Oficina de Estadística – Región Policial Cusco, Población INEI</p>`,
      },
    },
    budgetMenageMobilite: {
      es: {
        speech: `<p class="popup-information-text-speech">
                Este indicador proporciona información sobre el número de accidentes ocurridos en la red de carreteras de la Región de Cusco.
                </p>
                `,
        source: `<p class="popup-information-text-source">Siniestros totales en la Región del Cusco 2024 : adaptado de Oficina de Estadística – Región Policial Cusco, Proyecciones de Población Región de Cusco 2024 : INEI</p>`,
      },
    },
  },
  SumpTrajectory: {
    volumeDeplacementsJournaliersMode: {
      es: {
        speech: `<p class="popup-information-text-speech">
                El volumen de viajes diarios corresponde al número total de trayectos realizados cada día del área metropolitana*. Un viaje corresponde al trayecto realizado hasta el destino final por un motivo determinado, independientemente del número de medios de transporte utilizados durante dicho trayecto. Así, un viaje puede incluir varios medios de transporte, con conexiones. Sin embargo, un viaje no puede tener varios motivos a la vez. Por ejemplo, en el caso de un padre que va al trabajo y deja a su hijo en la escuela durante su trayecto en auto, se contabilizarán dos viajes: uno desde el domicilio hasta la escuela por el motivo «Acompañamiento» y otro por el motivo «Trabajo».
                </p>
                <p class="popup-information-text-conurbation">
                El área metropolitana abarca toda la provincia de Cusco y los distritos vecinos de Anta, Cachimayo, Huaracondo, Pucyura, Zurite, Urcos, Andahuaylillas, Huaro, Lucre, Oropesa, Chinchero y Huayllabamba
                </p>
                `,
        source: `<p class="popup-information-text-source">Estimaciones que cruzan varias encuestas: EODH, aforos y conteos de ascenso y descenso a bordo, escenario PMUS 2044</p>`,
      },
    },
    evolutionPartModaleDeplacementsQuotidiens: {
      es: {
        speech: `<p class="popup-information-text-speech">
                La partición modal de los viajes diarios corresponde a la repartición de los viajes realizados cada día en el área metropolitana* entre cada uno de los modos existantes. Este indicador permite observar el equilibrio entre los medios colectivos y de gran capacidad (en particular, el transporte público) y los medios no motorizados, como la caminata y la bicicleta, frente a los medios motorizados, como el automóvil particular o los vehículos de dos ruedas motorizados, que generan más molestias (congestión, contaminación, consumo de espacio y recursos). El seguimiento de la evolución de la partición modal permite observar si se produce un cambio modal. Por lo general, la cuota modal del transporte público representa entre el 10 % y el 60 % del total de los modos de transporte.
                </p>
                <p class="popup-information-text-conurbation">
                *El área metropolitana abarca toda la provincia de Cusco y los distritos vecinos de Anta, Cachimayo, Huaracondo, Pucyura, Zurite, Urcos, Andahuaylillas, Huaro, Lucre, Oropesa, Chinchero y Huayllabamba.
                </p>
                `,
        source: `<p class="popup-information-text-source">Estimaciones que cruzan varias encuestas: EODH, aforos y conteos de ascenso y descenso a bordo, escenario PMUS 2044</p>`,
      },
    },
    evolutionTauxMobilite: {
      es: {
        speech: `<p class="popup-information-text-speech">
                El índice de movilidad corresponde al número de viajes realizados al día por persona.
                </p>
                `,
        source: `<p class="popup-information-text-source">Estimaciones que cruzan varias encuestas: EODH, aforos y conteos de ascenso y descenso a bordo, escenario PMUS 2044</p>`,
      },
    },
    evolutionTauxMotorisation: {
      es: {
        speech: `<p class="popup-information-text-speech">
                Las tasas de motorización corresponden al número de vehículos que poseen los hogares del área metropolitana*. Se trata de automóviles para la tasa de autos, y de motos, scooters y ciclomotores para la tasa de motos. Se expresa en número de vehículos por cada 1000 habitantes. La tasa de motorización es un indicador esencial para determinar la importancia del vehículo individual en el territorio. A menudo sigue las tendencias del producto interno bruto (PIB): cuanto más alto es, más vehículos habrá. Con la coyuntura actual (aumento de los precios del combustible y de los vehículos, transición energética), es interesante seguir la evolución de la tasa de motorización de los vehículos de dos ruedas motorizados, puede observarse un cambio modal del automóvil hacia este modo de transporte menos costoso para los hogares.
                </p>
                <p class="popup-information-text-conurbation">
                *El área metropolitana abarca toda la provincia de Cusco y los distritos vecinos de Anta, Cachimayo, Huaracondo, Pucyura, Zurite, Urcos, Andahuaylillas, Huaro, Lucre, Oropesa, Chinchero y Huayllabamba.
                </p>
                `,
        source: `<p class="popup-information-text-source">EODH, Asociación Automotriz del Perú – AAP, proyecciones propias</p>`,
      },
    },
    partBudgetMoyenMobilite: {
      es: {
        speech: `<p class="popup-information-text-speech">
                Se trata del importe de los ingresos anuales de los hogares y la parte del presupuesto destinada a la movilidad, como el costo de los boletos de transporte, el combustible, el seguro de automóvil, etc. Las normas internacionales recomiendan que los hogares modestos no superen el 10 %.
                </p>
                `,
        source: `<p class="popup-information-text-source">Proyecciones de población a partir de datos del INEI 2017, Escenario PMUS 2044</p>`,
      },
    },
    voiesPrioritairesPietons: {
      es: {
        speech: `<p class="popup-information-text-speech">
                Este indicador proporciona información sobre el porcentaje de vías principales con prioridad peatonal en el área metropolitana*.
                </p>
                <p class="popup-information-text-conurbation">
                *El área metropolitana abarca toda la provincia de Cusco y los distritos vecinos de Anta, Cachimayo, Huaracondo, Pucyura, Zurite, Urcos, Andahuaylillas, Huaro, Lucre, Oropesa, Chinchero y Huayllabamba.
                </p>
                `,
        source: `<p class="popup-information-text-source">levantamiento topográfico, escenario PMUS 2044</p>`,
      },
    },
    infrastructuresCyclablesAvenues: {
      es: {
        speech: `<p class="popup-information-text-speech">
                Este indicador proporciona información sobre el porcentaje de vías principales con infraestructura ciclovial (carriles bici) en el área metropolitana*.
                </p>
                <p class="popup-information-text-conurbation">
                *El área metropolitana abarca toda la provincia de Cusco y los distritos vecinos de Anta, Cachimayo, Huaracondo, Pucyura, Zurite, Urcos, Andahuaylillas, Huaro, Lucre, Oropesa, Chinchero y Huayllabamba.                </p>
                `,
        source: `<p class="popup-information-text-source">levantamiento topográfico, escenario PMUS 2044</p>`,
      },
    },
    dureeMoyenneTrajet: {
      es: {
        speech: `<p class="popup-information-text-speech">
                El tiempo promedio de viaje en un territorio depende de varios factores: de la geografía del territorio (polaridades, expansión urbana), y también de las infraestructuras viarias y de los servicios de transporte público, así como su adecuado dimensionamiento (presencia o no de congestión).                </p>
                `,
        source: `<p class="popup-information-text-source">EODH, escenario PMUS 2044</p>`,
      },
    },
    longueurVoiesTransportPublic: {
      es: {
        speech: `<p class="popup-information-text-speech">
                Este indicador proporciona información sobre el número de kilómetros de vías con prioridad de transporte público (BRT, vías reservadas para autobuses) en el área metropolitana*.
                </p>
                <p class="popup-information-text-conurbation">
                *El área metropolitana abarca toda la provincia de Cusco y los distritos vecinos de Anta, Cachimayo, Huaracondo, Pucyura, Zurite, Urcos, Andahuaylillas, Huaro, Lucre, Oropesa, Chinchero y Huayllabamba.
                </p>
                `,
        source: `<p class="popup-information-text-source">Escenario PMUS 2044</p>`,
      },
    },
    longueurVoiesRapides: {
      es: {
        speech: `<p class="popup-information-text-speech">
                Este indicador proporciona información sobre el número de kilómetros de vías rápidas en el área metropolitana*.
                </p>
                <p class="popup-information-text-conurbation">
                *El área metropolitana abarca toda la provincia de Cusco y los distritos vecinos de Anta, Cachimayo, Huaracondo, Pucyura, Zurite, Urcos, Andahuaylillas, Huaro, Lucre, Oropesa, Chinchero y Huayllabamba
                </p>
                `,
        source: `<p class="popup-information-text-source">Escenario PMUS 2044</p>`,
      },
    },
    tauxCouvertureReseauTransportUrbain: {
      es: {
        speech: `<p class="popup-information-text-speech">
                Se trata de la parte de la población que reside a menos de 300 metros de una línea de transporte público. Es un indicador estratégico para evaluar el nivel de cobertura del transporte público.
                </p>
                `,
        source: `<p class="popup-information-text-source">Proyecciones de población a partir de datos del INEI 2017, Escenario PMUS 2044</p>`,
      },
    },
    femmesEntreprisesTransport: {
      es: {
        speech: `<p class="popup-information-text-speech">
                Este indicador muestra la proporción de mujeres en la plantilla de las empresas de transporte.
                </p>
                `,
        source: `<p class="popup-information-text-source">Empresas de transporte</p>`,
      },
    },
    accidentsRoutes: {
      es: {
        speech: `<p class="popup-information-text-speech">
                Este indicador proporciona información sobre el número de accidentes con víctimas (mortales, heridos graves, heridos leves) ocurridos en la red de carreteras de la provincia de Cusco.
                </p>
                `,
        source: `<p class="popup-information-text-source">Siniestros en la Provincia de Cusco 2024 - Oficina de Estadística – Región Policial Cusco, Población INEI</p>`,
      },
    },
    accesPmrTc: {
      es: {
        speech: `<p class="popup-information-text-speech">
                Se trata del porcentaje del parque equipado para acoger a personas con movilidad reducida. La calidad de una red también se mide por su capacidad para acoger a todos los públicos, incluidas las personas con movilidad reducida (PMR). Una red accesible requiere tanto un material rodante adaptado como instalaciones adecuadas en las paradas.
                </p>
                `,
        source: `<p class="popup-information-text-source">Escenario PMUS 2044</p>`,
      },
    },
    emissionPm: {
      es: {
        speech: `<p class="popup-information-text-speech">
                Las emisiones de partículas finas de diámetro inferior a 2,5 µm, provienen de varias fuentes : consumo de combustible, neumáticos y frenos y desgaste de la carretera.
                </p>
                `,
        source: `<p class="popup-information-text-source">Valores habituales de factores de emisión, viajes resultantes de la EODH, parque de vehículos procedente del AAP, de la MPC y de aforos en campo. Escenario PMUS 2044</p>`,
      },
    },
    emissionCo2: {
      es: {
        speech: `<p class="popup-information-text-speech">
                Las emisiones de gases de efecto invernadero (GEI) se calculan teniendo en cuenta el tipo de vehículo y su consumo energético, asociado a un factor de emisión. A continuación, las emisiones por modo se combinan con el número total de kilómetros recorridos anualmente por la flota de vehículos (conocida o estimada por cálculo). Este número se divide luego por la población total para obtener una relación de GEI por habitante y por año. El indicador se expresa en kgCO2/año/habitante equivalente.
                </p>
                `,
        source: `<p class="popup-information-text-source">Valores habituales de factores de emisión, viajes resultantes de la EODH, parque de vehículos procedente del AAP, de la MPC y de aforos en campo. Escenario PMUS 2044</p>`,
      },
    },
    dureeMoyenneTrajetCuscoChinchero: {
      es: {
        speech: `<p class="popup-information-text-speech">
                Los tiempos de viajes entre los principales polos de una metrópoli son un indicador de una metrópoli dinámica y equilibrada.
                </p>
                `,
        source: `<p class="popup-information-text-source">Escenario PMUS 2044</p>`,
      },
    },
    dureeMoyenneTrajetCuscoUrcos: {
      es: {
        speech: `<p class="popup-information-text-speech">
                Los tiempos de viajes entre los principales polos de una metrópoli son un indicador de una metrópoli dinámica y equilibrada.
                </p>
                `,
        source: `<p class="popup-information-text-source">Escenario PMUS 2044</p>`,
      },
    },
  },
  SumpManagement: {
    Gantt: {
      es: {
        speech: `Esta tabla muestra el estado de avance del plan de movilidad urbana sostenible (PMUS) sobre la base de una actualización anual. Cada acción se colorea según su grado de avance.`,
        source: ``,
      },
    },
  },
};

module.exports = {
  popupInformation,
};
